import * as type from './mutation-types'

const mutations = {
  [type.SET_MPVUEINFO] (state, mpvueInfo) { // eslint-disable-line
    state.mpvueInfo = mpvueInfo
  },

  [type.SET_TITLE] (state, title) {
    state.title = title
  },

  [type.SET_PROFILE] (state, profile) { // eslint-disable-line
    state.profile = profile
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js